<template>
  <div class="flex h-full w-16 absolute right-0 my-auto cursor-pointer">
    <div @click="nextCard()" class="w-16 h-16 my-auto">
      <img class="arrow-right cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-right.png" alt="arrow right">
    </div>
  </div>
</template>

<script>
export default {
  name: "NextArrow",
  props:{
    next:{
      required: true,
      type: String
    }
  },
  methods:{
    nextCard(){
      Event.$emit('clickedCard', this.next);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
